import React from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('userActions');

export default function TimelineDialog({ bodyContent, onClose, setIsActionRunning }) {
  const handleClose = () => {
    setIsActionRunning(false);
    onClose();
  };

  return (
    <Dialog modal open onClose={handleClose} disableBackdropClick>
      <DialogContent>
        <Alert severity="error">{locale.getMsg('warning')}</Alert>
        <div className="row timeline-warning-dialog">{bodyContent}</div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {locale.getMsg('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
